import styles from "../Daetong.module.css";
import { useNavigate, useParams } from "react-router-dom";

function FortuneSelect({ cards, personaList }) {
    const navigate = useNavigate();
    const { personaId } = useParams();
    const persona = personaList?.find(p => String(p.ID) === String(personaId));

    return (
        <div className={`mainContent ${styles.mainContent}`}>
            <div className={`mainInner ${styles.mainInner_daetong}`}>
                <div className='meadBox meadBox_daetong'>
                    <div className='main_top_banner'>
                        <div className="daetongCollect">
                            <h4 className="collectTitle">
                                <img src={process.env.PUBLIC_URL + `/daetongImg/collect_icon.png`} alt="" />
                                운세 선택
                                {persona && <span className={styles.personaNameBadge}>{persona.NAME}</span>}
                            </h4>
                            <ul className="daetongList">
                                {
                                    cards.map((card, i) => {
                                        return (
                                            <li key={i} onClick={() => navigate(`/daetong/FortuneInfo/${personaId}/${card.ORDER_ID}`)}>
                                                <div className="daetongList_inner">
                                                    <p className="unseIcon">
                                                        <img src={process.env.PUBLIC_URL + `/daetongImg/daetong_card_icon${card.ORDER_ID}.png`} alt='' />
                                                    </p>
                                                    <h5 className="daetong_unse_title">{card.TITLE}</h5>
                                                    <div className="daetong_unse_text">
                                                        {card.CONTENT}
                                                    </div>
                                                </div>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FortuneSelect;
